
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getBudgetReportMonthValueDtoFormGroup() {
return new FormGroup({
    month: new FormControl<number | undefined>(undefined, [Validators.required]),
    soll: new FormControl<number | undefined>(undefined, [Validators.required]),
    ist: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      